/* istanbul ignore file */
// @NOTE(jtan): This module should be used in non-components and as a replacement for injectIntl (to reduce component wrapping)

// @ts-expect-error [MIGRATION-SUPPRESSION]: TS1484
import { IntlShape, createIntl, createIntlCache } from 'react-intl';
// @ts-expect-error [MIGRATION-SUPPRESSION]: TS1484
import boxLanguages from '@box/languages';

// @ts-expect-error [MIGRATION-SUPPRESSION]: TS7034
let cachedBoxCldrData;
// @ts-expect-error [MIGRATION-SUPPRESSION]: TS7034
let cachedIntlProvider;

const assertIntlProviderExists = () => {
  // @ts-expect-error [MIGRATION-SUPPRESSION]: TS7005
  if (!cachedIntlProvider) {
    throw new Error(
      'i18n Error: User locale is not set properly. This can happen if you call `intl.formatMessage` before the current user is loaded.',
    );
  }
};

// @NOTE(jtan): Written as a normal function to avoid auto-formatting and flow issues with dynamic imports
function importLangBundle(language: string) {
  return import(
    // Keep webpackChunkName unique to avoid name collision with other modfed repos (eg: trigger client) in EUA or admin console,  which leads to bundle.js load issue FORMS-8689
    // more info: https://webpack.js.org/api/module-methods/#magic-comments
    /* webpackChunkName: "file-request-forms-lang-[request]" */ `lang-bundles/${language}`
  );
}

const loadLanguageBundle = (language: string) => {
  // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2693
  if (!boxLanguages.includes(language)) {
    return Promise.reject(new Error('i18n Error: Unsupported locale.'));
  }

  return importLangBundle(language).then(
    ({ language: locale, messages, boxCldrData }) => {
      cachedIntlProvider = createIntl({ locale, messages }, createIntlCache());
      cachedBoxCldrData = boxCldrData;
    },
  );
};

const createIntlProxyFunction = (method: string) => {
  // Retrieves the current intl object
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  return (...args: any) => {
    assertIntlProviderExists();
    // @ts-expect-error [MIGRATION-SUPPRESSION]: TS7005
    return cachedIntlProvider[method](...args);
  };
};
type Intl = {
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  boxCldrData: any;
  formatDate: IntlShape['formatDate'];
  formatMessage: IntlShape['formatMessage'];
  formatNumber: IntlShape['formatNumber'];
  // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2339
  formatRelative: IntlShape['formatRelative'];
  formatTime: IntlShape['formatTime'];
  locale: IntlShape['locale'];
  messages: IntlShape['messages'];
};

// We export proxied intl functions so we can use the right locale at runtime
const intl: Intl = {
  formatDate: createIntlProxyFunction('formatDate'),
  formatMessage: createIntlProxyFunction('formatMessage'),
  formatNumber: createIntlProxyFunction('formatNumber'),
  formatRelative: createIntlProxyFunction('formatRelative'),
  formatTime: createIntlProxyFunction('formatTime'),
  get locale() {
    assertIntlProviderExists();
    // @ts-expect-error [MIGRATION-SUPPRESSION]: TS7005
    return cachedIntlProvider.locale;
  },
  get messages() {
    assertIntlProviderExists();
    // @ts-expect-error [MIGRATION-SUPPRESSION]: TS7005
    return cachedIntlProvider.messages;
  },
  get boxCldrData() {
    assertIntlProviderExists();
    // @ts-expect-error [MIGRATION-SUPPRESSION]: TS7005
    return cachedBoxCldrData;
  },
};

export { loadLanguageBundle };
export default intl;
